import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationObject, DEFAULT_CONFIG_NAME, UNKNOWN_CONFIG_NAME } from '../store/configuration.datamodel';

@Pipe({
    name: 'configurationsTooltip',
    standalone: false
})
export class ConfigurationsTooltipPipe implements PipeTransform {
  /**
   * Map a given set of configurations by separator and join them by a separator
   * @param entities
   * @param take
   * @param sep
   */
  transform(entities: (ConfigurationObject | undefined)[], sep = ', '): string | undefined {
    if (entities.length === 0) {
      return undefined;
    }
    return entities
      .map(config => this.determinePluralTooltip(config))
      .join(sep);
  }

  /**
   * Determine the tooltip for the configuration in a list.
   * Show the config name and owner name in the tooltip if the config is not the default configuration.
   * Otherwise, show the configuration name.
   * @param config
   * @private
   */
  private determinePluralTooltip(config: ConfigurationObject | undefined) {
    if (config === undefined) {
      return DEFAULT_CONFIG_NAME;
    } else if (config.parentGuid) {
      return `${config.name} - ${config.actor?.actorName}`;
    } else if (!config.componentId || !config.guid) {
      return UNKNOWN_CONFIG_NAME;
    }
    return config.name ?? DEFAULT_CONFIG_NAME;
  }
}
